import React, { ComponentProps } from "react";
import { useCss, a } from "kremling";

import { CpCard, CpEmptyState } from "@components";

type CpEmptyStateCardProps = ComponentProps<"div"> & {
  img: string;
};

export function CpEmptyStateCard({
  className,
  ...props
}: CpEmptyStateCardProps) {
  const scope = useCss(styles);
  const { img, ...rest } = props;
  return (
    <CpCard {...scope} className={a("cp-empty-state-card", className)}>
      <CpEmptyState img={img} {...rest} />
    </CpCard>
  );
}

const styles = `
  .cp-empty-state-card {
    padding: 3.2rem;
    max-width: 46.4rem;
    margin-left: auto;
    margin-right: auto;
  }
`;
